import React, { useState } from 'react';
import { Button, DatePicker, Select, Space, message } from 'antd';
import dayjs from 'libs/dayjs';

const { RangePicker } = DatePicker;

// Contenido del popover que se abre al hacer clic en una barra: fechas y responsable de la
// tarea, con un solo guardado. Se usa también para fijar las fechas de una tarea sin
// fechas (barra fantasma).
//
// Props:
//   tarea — { id, description, planned_start, planned_end, assigned_to_user_id }
//   especialistas — [{ id, fullname }]
//   onGuardar(idTarea, campos) — devuelve la respuesta del API; con `codeMessage` es un error.
//   onCerrar() — se llama al guardar bien o al cancelar.
export default function GanttBarPopover({ tarea, especialistas = [], onGuardar, onCerrar }) {
  const [rango, setRango] = useState([
    tarea.planned_start ? dayjs(tarea.planned_start) : null,
    tarea.planned_end ? dayjs(tarea.planned_end) : null,
  ]);
  const [responsable, setResponsable] = useState(tarea.assigned_to_user_id ?? null);
  const [guardando, setGuardando] = useState(false);

  const guardar = async () => {
    const [inicio, fin] = rango ?? [null, null];
    setGuardando(true);
    const res = await onGuardar?.(tarea.id, {
      planned_start: inicio ? inicio.format('YYYY-MM-DD') : null,
      planned_end: fin ? fin.format('YYYY-MM-DD') : null,
      assigned_to_user_id: responsable ?? null,
    });
    setGuardando(false);
    if (res?.codeMessage) {
      message.error(res.message || 'No se pudo guardar la tarea');
      return;
    }
    onCerrar?.();
  };

  return (
    <div style={{ width: 280 }} data-testid="gantt-popover">
      <div style={{ fontWeight: 600, marginBottom: 8, wordBreak: 'break-word' }}>
        {tarea.description}
      </div>
      <Space direction="vertical" size={10} style={{ width: '100%' }}>
        <div>
          <div style={{ marginBottom: 4, fontSize: 12 }}>Fechas</div>
          <RangePicker
            aria-label="Fechas"
            format="DD/MM/YYYY"
            value={rango}
            onChange={setRango}
            allowClear={false}
            style={{ width: '100%' }}
            getPopupContainer={(el) => el.parentElement}
          />
        </div>
        <div>
          <div style={{ marginBottom: 4, fontSize: 12 }}>Responsable</div>
          <Select
            aria-label="Responsable"
            value={responsable ?? undefined}
            allowClear
            showSearch
            placeholder="Sin asignar"
            optionFilterProp="label"
            style={{ width: '100%' }}
            onChange={(next) => setResponsable(next ?? null)}
            options={especialistas.map((u) => ({ value: u.id, label: `${u.fullname}` }))}
            getPopupContainer={(el) => el.parentElement}
          />
        </div>
        <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button size="small" onClick={onCerrar}>
            Cancelar
          </Button>
          <Button size="small" type="primary" loading={guardando} onClick={guardar}>
            Guardar
          </Button>
        </Space>
      </Space>
    </div>
  );
}
